var _circle, _circle2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6059,
    cy: 12.3216,
    r: 3.87879,
    stroke: "#EF5918",
    strokeWidth: 1.93939
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3635,
    cy: 20.0792,
    r: 3.87879,
    stroke: "#FF7E47",
    strokeWidth: 1.93939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3633 10.1443L18.7212 8.48549C18.1473 7.90584 18.2592 6.9436 18.9507 6.51105L20.9695 5.24829",
    stroke: "#EF5918",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.7627 7.63593C24.7296 8.07661 26.8203 9.49592 26.3969 14.1036",
    stroke: "#F3A685",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4315 22.2915L14.0736 23.9503C14.6475 24.53 14.5356 25.4922 13.8441 25.9247L11.8253 27.1875",
    stroke: "#EF5918",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.0321 24.7999C8.0652 24.3592 5.97454 22.9399 6.39795 18.3322",
    stroke: "#F3A685",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebase);
export default __webpack_public_path__ + "static/media/Rebase.7a7f55987eed7bb8db0df876662acdd3.svg";
export { ForwardRef as ReactComponent };